/** The pages a visitor — or an ad network, a host, or a rights holder — goes looking for.
 *  Listed in one array so the footer cannot fall out of step with the routes. The user guide leads; it is not a legal page, but it
 *  is exactly what this row is for — the page somebody goes looking for. */
export const SITE_PAGE_LINKS: ReadonlyArray<{ to: string; label: string }> = [
  { to: "/how", label: "How to goon" },
  { to: "/terms", label: "Terms" },
  { to: "/privacy", label: "Privacy" },
  { to: "/dmca", label: "DMCA" },
  { to: "/2257", label: "2257" },
  { to: "/contact", label: "Contact" },
];

/** The user guide's entry — "How to goon" wherever it is linked. */
export const HOW_TO_LINK = SITE_PAGE_LINKS[0]!;
